import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import JobsFilter from 'app/Components/Page/CellcomCareersPage/Shared/Utils/JobsFilter/JobsFilter';
import Config from 'app/Config';
import {gtag4} from 'app/utilities/analytics/tracking';

const CareersMainBlock = ({
  data,
  utilsJob,
  filterJobData,
  adsCareersData,
  pageCareersSetting,
  updateAds,
  selectedUtils,
  locationCareersData,
  careerScopeList,
  gtag4,
}) => {
  const [headerTitle, setHeaderTitle] = useState({
    main: '',
    sub: '',
    jobTitle: '',
  });
  const [bannerImg, setBannerImg] = useState({});
  const [isMobile, setIsMobile] = useState(window.innerWidth < 767);

  useEffect(() => {
    if (pageCareersSetting) {
      setHeaderTitle(pageCareersSetting);
      setBannerImg(setBannerData(pageCareersSetting, isMobile));
    }
  }, [pageCareersSetting, isMobile]);

  useEffect(() => {
    function reportWindowSize() {
      setIsMobile(window.innerWidth < 767);
    }

    window.addEventListener('resize', reportWindowSize);

    return () => {
      window.removeEventListener('resize', reportWindowSize);
    };
  }, []);

  const handleSelectUtils = (scope) => {
    gtag4({
      event: `CellcomJobs_CategoryClick`,
      button: scope,
      action: 'CategoryClick',
    });

    const selectedCities = locationCareersData.reduce((cities, region) => {
      if (region.checked && region.cities) {
        region.cities.forEach((city) => cities.push(city.name));
      }
      return cities;
    }, []);
    const selectedScope = careerScopeList
      .filter((scope) => {
        if (scope.checked) return scope.label;
      })
      .map((y) => y.label);
    const isEmptyFilter = filterJobData[0] === 'SHOW_ALL';

    updateAds({
      selectedUtil: scope,
      adsCareers: adsCareersData,
      filterJob: isEmptyFilter ? [] : filterJobData,
      type: 'UTILS',
      selectedCities: selectedCities,
      selectedScope: selectedScope,
    });
  };

  return (
    <div>
      <div className='careers__container'>
        {bannerImg?.image && <Image className='careers__container__image' src={bannerImg?.image} alt='background' />}
        <div className='careers__container__main-header' dangerouslySetInnerHTML={{__html: data.mainTitle?.value}} />
        <div className='careers__container__sub-header' dangerouslySetInnerHTML={{__html: data.subTitle?.value}} />
        <div className='careers__container__jobTitle-header' dangerouslySetInnerHTML={{__html: data.jobTitle?.value}} />

        <JobsFilter
          selectedUtils={selectedUtils}
          utilJobsList={utilsJob}
          adsCareers={adsCareersData}
          updateAds={updateAds}
          handleSelectUtils={handleSelectUtils}
        />
      </div>
    </div>
  );
};

export default CareersMainBlock;

function setBannerData(data, isMobile) {
  const bannerData = {};
  bannerData.image = isMobile ? Config.epiBaseUrl + data.imgMobile : Config.epiBaseUrl + data.imgDesktop;

  return bannerData;
}
